import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../../components/Layout";
import FinalCtaPanel from "../../components/FinalCtaPanel";
import "../../styles/brand.css";
import TrainingHero from "../trainings/TrainingHero";
import IsoCourseGrid from "./IsoCourseGrid";
import { CATEGORY_ORDER, isoLeadAuditorCourses } from "./isoLeadAuditorData";
import { BookOpenIcon } from "./isoIcons";
import { trainingCtaContent } from "./isoTrainingCta";

const SITE_URL = "https://mbasolutions.co";

/* The full listing of every category. Each category also has a page of its own
   under /services/<slug> (see ServiceCategoryPage) — this page stays as the
   complete index, and renders through the SAME grid and the SAME closing CTA,
   so there is one copy of each. The hash-scroll is kept: existing links into
   #quality and friends still land in the right place. */
const IsoLeadAuditorTraining = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    const timer = window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 120);
    return () => window.clearTimeout(timer);
  }, [location.hash]);

  return (
    <Layout
      title="MBA Solutions - ISO Lead Auditor Trainings"
      description={`Advance your auditing career with ${isoLeadAuditorCourses.length}+ internationally recognized ISO Lead Auditor certification training programs from MBA Solutions.`}
      keywords="ISO Lead Auditor training, ISO 9001 training, ISO 27001, ISO 45001, lead auditor certification, MBA Solutions"
      canonical={`${SITE_URL}/iso-lead-auditor-training`}
    >
      <main className="brand-page bg-white">
        <TrainingHero
          badge="Internationally Recognized Programs"
          title="ISO Lead Auditor Trainings"
          subtitle={`Advance your auditing career with ${isoLeadAuditorCourses.length}+ internationally recognized certification training programs designed for professionals and consultants.`}
          icon={BookOpenIcon}
          primaryCta={{ label: "Contact Us", to: "/contact" }}
          secondaryCta={{ label: "All Training", to: "/training" }}
        />

        <IsoCourseGrid categories={CATEGORY_ORDER} />

        <FinalCtaPanel
          id="iso-lead-auditor-cta-heading"
          title={trainingCtaContent.title}
          paragraph={trainingCtaContent.paragraph}
          cta={trainingCtaContent.cta}
          image={trainingCtaContent.image}
        />
      </main>
    </Layout>
  );
};

export default IsoLeadAuditorTraining;
